import React, { useEffect } from "react";
import "../App.css";
import { useOutletContext } from "react-router-dom";

import RecoverPasswordPage from "../components/recoverPassword/recoverPassword";

export default function RecoverPassword() {
  const [
    auth,
    setAuth,
    user,
    setUser,
    darkmode,
    setDarkmode,
    nav,
    setNav,
    setError,
  ]: any = useOutletContext();

  // useEffect(() => {
  //   setNav({ ...nav, page: "profile" });
  // }, []);

  return (
    <div className="row">
      <RecoverPasswordPage
        auth={auth}
        setAuth={setAuth}
        user={user}
        setUser={setUser}
      />
    </div>
  );
}
